"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardItemHierarchySerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
class StandardItemHierarchySerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(standardSetSerializer, standardItemSerializer) {
        super();
        this.standardSetSerializer = standardSetSerializer;
        this.standardItemSerializer = standardItemSerializer;
    }
    serializeOne(data) {
        return {
            standardSet: data.standardSet &&
                this.standardSetSerializer.serializeOne(data.standardSet),
            subject: data.subject &&
                this.standardSetSerializer.serializeSubject(data.subject),
            items: this.serializeItems(data.items),
        };
    }
    serializeItems(data) {
        let children;
        if (data.children)
            children = this.serializeItems(data.children);
        return {
            hierarchyTree: data.hierarchyTree &&
                this.standardSetSerializer.serializeHierarchy(data.hierarchyTree),
            items: (data.items || []).map((item) => this.standardItemSerializer.serializeOne(item)),
            children: children,
        };
    }
}
exports.StandardItemHierarchySerializer = StandardItemHierarchySerializer;
//# sourceMappingURL=standard-item-hierarchy.serializer.js.map